"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./landing.scss");
var birukTesfayelogo_svg_1 = __importDefault(require("../../../Assets/icons/birukTesfayelogo.svg"));
var Landing = /** @class */ (function (_super) {
    __extends(Landing, _super);
    function Landing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Landing.prototype.componentDidMount = function () {
        window.addEventListener('load', function () {
            var name_container = document.getElementById('name-container');
            var logo = document.getElementById('logo');
            var name = document.getElementsByClassName('name-cls');
            // let tag:HTMLElement | any = document.getElementById('typewriter-effect')
            name_container.style.width = '50%';
            name_container.style.opacity = 1;
            logo.style.opacity = 1;
            for (var n = 0; n < 2; n++) {
                name[n].style.opacity = 1;
            }
        });
    };
    Landing.prototype.render = function () {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: 'landing-container' },
                react_1.default.createElement("div", { className: 'logo', id: 'logo', style: {
                        backgroundImage: "url(" + birukTesfayelogo_svg_1.default + ")"
                    } }),
                react_1.default.createElement("div", { className: 'name-container animate-name-container', id: 'name-container' },
                    react_1.default.createElement("span", { className: 'name-cls' }, "Biruk"),
                    react_1.default.createElement("span", { className: 'name-cls' }, "Tesfaye")),
                react_1.default.createElement("div", { className: 'tag-container' },
                    react_1.default.createElement("h2", { className: 'typewriter-effect', id: 'typewriter-effect' }, "Glad to meet you!")),
                react_1.default.createElement("div", { className: 'down-arrow-container ' },
                    react_1.default.createElement("a", { href: "#about_me" },
                        react_1.default.createElement("i", { className: 'fa fa-angle-down fa-3x' }))))));
    };
    return Landing;
}(react_1.Component));
exports.Landing = Landing;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/Landing/Landing.tsx
// module id = 62
// module chunks = 0